import { BASE_ADMIN_API, fetchAPI } from '@/services/api';

/** nodeCode -> itemKey -> rate percent (0-100). Node-level uses itemKey "rate". */
export type IrdRateNodes = Record<string, Record<string, number>>;

export interface IrdRateConfigVO {
    nodes?: IrdRateNodes;
}

export interface IrdRateConfigBO {
    nodes: IrdRateNodes;
}

const base = `${BASE_ADMIN_API}/ird-rate`;

export async function getConfig() {
    return fetchAPI<IrdRateConfigVO>(`${base}/get`, { method: 'GET' });
}

export async function updateConfig(bo: IrdRateConfigBO) {
    return fetchAPI<boolean>(`${base}/update`, {
        method: 'PUT',
        body: JSON.stringify(bo),
    });
}

export const IrdRateService = {
    getConfig,
    updateConfig,
};
